  // Enum for evaluation results
  const EvaluationResult = {
    CRITERIA_MET: 'The criteria are met.',
    CRITERIA_NOT_MET: 'The criteria are not met.',
    NOT_ASSESSABLE: 'This criteria is not assessable.',
  };

  const translations = {
    english: {
      CRITERIA_MET: 'The criteria are met.',
      CRITERIA_NOT_MET: 'The criteria are not met.',
      NOT_ASSESSABLE: 'The criteria are not assessable.',
    },
    german: {
      CRITERIA_MET: 'Die Kriterien sind erfüllt.',
      CRITERIA_NOT_MET: 'Die Kriterien sind nicht erfüllt.',
      NOT_ASSESSABLE: 'Dieses Kriterium ist nicht bewertbar.',
    },
    italian: {
      CRITERIA_MET: 'I criteri sono soddisfatti.',
      CRITERIA_NOT_MET: 'I criteri non sono soddisfatti.',
      NOT_ASSESSABLE: 'Questo criterio non è valutabile.',
    },
    czech: {
      CRITERIA_MET: 'Kritéria jsou splněna.',
      CRITERIA_NOT_MET: 'Kritéria nejsou splněna.',
      NOT_ASSESSABLE: 'Toto kritérium nelze hodnotit.',
    }
};

  function evaluateAnswersSC(answers) {
    const filteredAnswers = Array.isArray(answers) ? answers.filter(answer => answer.questionType !== "Blank") : [];
    const SubstentialContribution = filteredAnswers.filter(answer => answer.questionCategory === 'Substantial Contribution');
    const evaluateAnswersOld = (answers) => 
        answers.length > 0 && answers.every(answer =>
        answer.requireForEvaluation 
        ? answer.answer.every(ans => ans.trim() !== "")
        : true // Skip non-required answers
    );

    return evaluateAnswersOld(SubstentialContribution);
  }

  function evaluateFlagsForQuestion(optionsWithFlagMap, question, answer) {
    /*if(question.questionID == 803 || question.questionID == 601) {
      console.log("question", question);
      console.log("answer", answer);
    }*/
      
    if (question.questionType === 'Input Validation' && answer != "") {
      const startLimit = Number(question.options[0]);
      const endLimit = Number(question.options[1]);

      if (Number(answer) >= startLimit && Number(answer) < endLimit) {
        return EvaluationResult.CRITERIA_MET;
      } else {
        return EvaluationResult.CRITERIA_NOT_MET;
      }
    }

    if (question.questionType === 'Calculation') {
      const answerArray = answer;
      let stringFormula = question.calculation;

      if (!Array.isArray(answerArray)) {
        return EvaluationResult.NOT_ASSESSABLE;
      }

      // Create a mapping of variables to their corresponding values
      const variables = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      
      // Replace variables in the formula with corresponding values from the answerArray
      for (let i = 0; i < variables.length; i++) {
          const regex = new RegExp(`\\b${variables[i]}\\b`, 'g');
          const value = answerArray[i] !== undefined ? Number(answerArray[i]) : 0; // Default to 0 if undefined
          stringFormula = stringFormula.replace(regex, value); // Replace variable with its value
      }

      // Evaluate the formula
      try {
          const result = eval(stringFormula);
          return result ? EvaluationResult.CRITERIA_MET : EvaluationResult.CRITERIA_NOT_MET;
      } catch (error) {
          console.error('Error evaluating formula:', error);
          return EvaluationResult.NOT_ASSESSABLE;
      }
    }

    // Retrieve options for the given questionID
    const optionsForQuestion = optionsWithFlagMap.get(question.questionID);

    // If optionsForQuestion is not an array, or is empty, return undefined
    if (!Array.isArray(optionsForQuestion) || optionsForQuestion.length === 0) {
        return undefined;
    }

    // Check if all flags are undefined
    const allFlagsUndefined = optionsForQuestion.every(option => option === undefined);
    if (allFlagsUndefined) {
        return undefined;
    }

    // Check if at least one flag is false
    const hasFalseFlag = optionsForQuestion.some(option => option === false);
    if (hasFalseFlag) {
        return EvaluationResult.CRITERIA_NOT_MET;
    }

    // Check if at least one flag is set to not assessable
    const hasNotAssessableFlag = optionsForQuestion.some(option => option === "Not Assessable");
    if (hasNotAssessableFlag) {
        return EvaluationResult.NOT_ASSESSABLE;
    }

    // Check if all flags are true
    const allFlagsTrue = optionsForQuestion.every(option => option === true);

    return allFlagsTrue ? EvaluationResult.CRITERIA_MET : EvaluationResult.CRITERIA_NOT_MET;
};

  function evaluateAnswers(answers, category, categoryIsAssessable = true) {
    // Validate the `answers` array
    if (!Array.isArray(answers)) {
        return EvaluationResult.CRITERIA_NOT_MET;
    }

    // Filter answers by category
    const filteredForCategory = answers
        .filter(answer => answer.questionCategory === category)
        .filter(answer => (!Array.isArray(answer.answer) && answer.answer.trim() !== "") || Array.isArray(answer.answer) )
        .filter(answer => answer.questionType !== "Blank" && answer.questionType !== "File");

    /*if(category == 'Substantial Contribution')
      console.log("filteredForCategory", filteredForCategory)*/

    // No questions for the category
    if (filteredForCategory.length === 0) {
        return EvaluationResult.CRITERIA_MET; 
    }

    // Check if any answer was marked as NOT meeting this category's criteria
    if (filteredForCategory.some(answer => answer.meetsCriteria === false || answer.meetsCriteria === EvaluationResult.CRITERIA_NOT_MET)) {
        return EvaluationResult.CRITERIA_NOT_MET;
    }

    // Check if any answer was marked as meeting this category's criteria
    if (filteredForCategory.some(answer => answer.meetsCriteria === true || answer.meetsCriteria === EvaluationResult.CRITERIA_MET)) {
        return EvaluationResult.CRITERIA_MET;
    }

    // Check if any answer was marked as not assessable
    if (filteredForCategory.some(answer => answer.meetsCriteria === EvaluationResult.NOT_ASSESSABLE)) {
        return EvaluationResult.NOT_ASSESSABLE;
    }

    // Check if all required answers are filled
    const areAllRequiredAnswersFilled = filteredForCategory.every(answer => {
        if (!answer.requireForEvaluation) {
            return true; // Skip non-required answers
        }

        // If the answer is a string (for Long Text or similar questions)
        if (typeof answer.answer === 'string') {
            return answer.answer.trim() !== ""; // Check if the string is not empty after trimming whitespace
        }

        // If the answer is an array (for Multiple Choice or similar questions)
        if (Array.isArray(answer.answer)) {
            return answer.answer.every(ans => ans.trim() !== ""); // Check that no element in the array is an empty string
        }

        // Return false if answer type is neither string nor array
        return false;
    });

    if (areAllRequiredAnswersFilled && categoryIsAssessable) {
        return EvaluationResult.CRITERIA_MET;
    }

    // Category is marked as not assessable (for example Adaptation)
    if (areAllRequiredAnswersFilled && !categoryIsAssessable) {
        return EvaluationResult.NOT_ASSESSABLE;
    }

    // Not all answers were filled out
    return EvaluationResult.CRITERIA_NOT_MET;
  }

  function getColorForStatus(status) {
    switch (status) {
        case EvaluationResult.CRITERIA_MET:
            return "green-dot mx-4";
        case EvaluationResult.CRITERIA_NOT_MET:
          return "orange-dot mx-4";
        case EvaluationResult.NOT_ASSESSABLE:
          return "grey-dot mx-4";
        default:
          return "grey-dot mx-4";
      }
  }

  function getTranslationForStatus(status, language) {
    switch (status) {
        case EvaluationResult.CRITERIA_MET:
            return translations[language].CRITERIA_MET;
        case EvaluationResult.CRITERIA_NOT_MET:
          return translations[language].CRITERIA_NOT_MET;
        case EvaluationResult.NOT_ASSESSABLE:
          return translations[language].NOT_ASSESSABLE;
        default:
          return "";
      }
  }
  
  export { evaluateAnswersSC, evaluateFlagsForQuestion, getColorForStatus, EvaluationResult, evaluateAnswers, getTranslationForStatus };
